/**
 * Affichage des rapports liés au cours passés.
 */

import { Component, OnInit } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { RateStudentService } from '../../../../../../shared/src/lib/service/rate-student.service';
import { PendingService } from '../../../../../../shared/src/lib/service/pending.service';
import { environment } from '../../../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../../../../shared/src/lib/service/authentification.service';
import { OccurrenceService } from '../../../../../../shared/src/lib/service/occurrence.service';
import { Occurrence } from '../../../../../../shared/src/lib/model/occurrence.model';
@Component({
  selector: 'app-past',
  templateUrl: './past.component.html',
  styleUrls: ['./past.component.scss']
})
export class PastComponent implements OnInit {
  loading_pending = false;
  loadingCompletedReport = false;
  nextPagesPending = null;
  nextPagesCompleted = null;
  ratingStudents: any[] = [];
  pendings: any[] = [];
  formation_id: any;
  myUser: any;
  countPendings = 0;
  defaultAvatar = environment.static + '/avatar.png';
  constructor(
    private occurrenceService: OccurrenceService,
    private pendingService: PendingService,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.authenticationService.currentUserSubject.subscribe(
      user => {
        if (user && user.hasOwnProperty('user')) {
          this.myUser = user;
        }
      }
    )
    this.formation_id = this.route.parent.snapshot.params.id_formation;
    this.getPendings();
    this.getFilterCompletedReports();
  }

  getFilterCompletedReports() {
    this.loadingCompletedReport = true;

    const params = {
      'page': 1,
      'formation': this.formation_id,
      'ordering': '-start',
      'status__in': 'done,abs_student_without_justification,abs_teacher_without_justification'
    }
    let url = this.occurrenceService.setUrlWithParams('occurrences', params);
    if (this.nextPagesCompleted) {
      url = this.nextPagesCompleted;
    }
    this.occurrenceService.getObservableOccurence(url)
      .subscribe(_ratingStudents => {
        if (_ratingStudents) {
          if (_ratingStudents['next']) {
            this.nextPagesCompleted = _ratingStudents['next'];
          } else {
            this.nextPagesCompleted = null;
          }
          // On incremente les données
          if (_ratingStudents['results']) {
            for (const _rating of _ratingStudents['results']) {
              this.ratingStudents.push(_rating)
            }
          }
        }
        else {
          this.nextPagesCompleted = null;
        }
        this.loadingCompletedReport = false;
      });
  }

  getPendings() {
    this.loading_pending = true;
    const params = {
      'page': 1,
      'formation': this.formation_id,
      'salt': Math.random().toString(),
      'teacher': this.myUser.id,
    }
    let url = this.pendingService.setUrlWithParams('pendings', params);
    if (this.nextPagesPending) {
      url = this.nextPagesPending;
    }
    this.pendingService.getPendingsByUrl(url)
      .subscribe(_pendings => {
        if (_pendings) {
          if (_pendings['next']) {
            this.nextPagesPending = _pendings['next'];
          } else {
            this.nextPagesPending = null;
          }
          if (_pendings['results']) {
            _pendings['results'].forEach(_pending => {
              let exist = false;
              this.pendings.forEach(_existing => {
                if (_pending.url === _existing.url) {
                  exist = true;
                }
              });
              if (!exist) {
                if (_pending.teacher.url === this.myUser.url) {
                  this.countPendings += 1;
                  this.pendings.push(_pending)
                }
              }
            });
            this.loading_pending = false;
          }
        } else {
          this.nextPagesPending = null;
        }
      });
  }

  goToInfo(_occurrence: Occurrence) {
    if (_occurrence.session.rate_teacher && _occurrence.status === 'done') {
      this.router.navigate(['reports', 'info', _occurrence.session.id]);
    }
  }

}
